<script setup lang="ts">
import plus from '@/assets/school-grades/plus.svg';
import minus from '@/assets/school-grades/minus.svg';

defineProps<{ modifier: -1 | 1 }>();
</script>

<template>
  <span class="inline-flex shrink-0 items-center justify-center" aria-hidden="true">
    <img
      :src="modifier === 1 ? plus : minus"
      class="block w-full"
      :class="modifier === 1 ? 'h-full' : 'h-1/4'"
      alt=""
      draggable="false"
    />
  </span>
</template>
